/* Anakaty — collection controls progressive enhancement.
   The filter/sort form is a plain GET form and works with this file absent
   or blocked. This only removes the manual Apply buttons and submits on
   change — and it removes them AFTER the listener is attached, so there is
   never a moment where neither path works. */
(function () {
  'use strict';

  function enhance(form) {
    if (form.dataset.acsEnhanced === 'true') return;
    form.dataset.acsEnhanced = 'true';

    form.addEventListener('change', function (event) {
      var field = event.target;
      if (!field || field.dataset.acsNoAuto === 'true') return;
      if (field.type === 'number' || field.type === 'text') return;
      form.requestSubmit ? form.requestSubmit() : form.submit();
    });

    // Only drop an Apply button once its panel has no free-text/number field,
    // because those must not submit on every keystroke or spinner step.
    form.querySelectorAll('[data-acs-apply]').forEach(function (button) {
      var scope = button.closest('[data-acs-scope]') || form;
      if (scope.querySelector('input[type="number"], input[type="text"]')) return;
      button.hidden = true;
    });
  }

  function init() {
    document.querySelectorAll('[data-acs-controls]').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', init);
})();
